import { FullScreenContainer, StyledSpin } from './SuspenseLoader.styled';

const SuspenseLoader = () => (
  <FullScreenContainer data-testid="suspense-loader">
    <StyledSpin size="large" />
  </FullScreenContainer>
);

export default SuspenseLoader;
